import React from 'react';
import Drawer from './Drawer.jsx'
import Waitlist from './Waitlist.jsx';
import ProductColors from './ProductColors.jsx';
import ProductPromos from './ProductPromos.jsx';
import ProductSwitcher from './ProductSwitcher.jsx';
import Axios from 'axios';
import CartMini from '../components/CartMini';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';

export default class ProductForm extends React.PureComponent {
  constructor(props) {
    super();

    this.state = {cartButton: '', invalidVariant: false, shipModalOpen: false};

    this._optionChanged = this._optionChanged.bind(this);
    this._invalidVariant = this._invalidVariant.bind(this);
    this.formData = this.formData.bind(this);
    this.inventoryAlert = this.inventoryAlert.bind(this);
    this.formButton = this.formButton.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.waitlist = this.waitlist.bind(this);
    this.shipNote = this.shipNote.bind(this);

    this._openShipModal = this._openShipModal.bind(this);
    this._closeShipModal = this._closeShipModal.bind(this);

    this.cartMini = new CartMini();

    this.ref = React.createRef();
    window.dataLayer = window.dataLayer || [];
  }

  _openShipModal(e) {
    e.preventDefault();
    this.setState({shipModalOpen: true});
  }

  _closeShipModal() {
    this.setState({shipModalOpen: false});
  }


  _optionChanged(name, value) {
    this.props.onOptionChange(name, value);
  }

  _invalidVariant() {
    this.setState({invalidVariant: true}, () => {
      this.ref.current.scrollIntoView({behavior: 'smooth'})
    });

    for (let i = 0; i < this.props.product.options.length; i++) {
      const keyName = `option${i + 1}`;
      if (!this.props[keyName]) {
        window.dataLayer.push({ 'event': 'ATC Option Unselected', 'option_unselected': this.props.product.options[i] });
      }
    }
  }

  formData() {
    if (this.props.product.variants.length === 1) {
      return (null);
    }
    return this.props.product.options_with_values.map((option, i) => {
      const keyName = `option${i + 1}`;
      let cName = 'option-wrapper';
      if (option.name === 'Size') {
        cName += ' option-handle-size';
        
        if (["boots", "Shoes", "Sneakers"].includes(this.props.product.type)) {
          cName += ' localize-sizes'
        }
      }
      if (option.name === 'Width') {
        cName += ' option-handle-width';
      }
      if (option.name === 'Fit') {
        cName += ' option-handle-fit';
      }
      if (this.state.invalidVariant && !this.props[keyName]) {
        cName += ' unselected';
      }
      if (this.props.product.tags.includes('extended-sizes')) {
        cName += ' extended-sizes'
      }
      if (this.props.product.tags.includes('fullwidth-sizes')) {
        cName += ' fullwidth-sizes'
      }
      return <div className={cName} data-option-wrapper={option.name} key={i}>
        <div className="option-header">
          <span className="option-name">{option.name}:{' '}</span> 
          {option.name === 'Size' ? <ProductPromos product={this.props.product} blocks={this.props.blocks} position="above-atc-smart-2" _openSizeGuide={this.props._openSizeGuide} _optionChanged={this._optionChanged} /> : null}
          {option.name === 'Fit' ? <ProductPromos product={this.props.product} blocks={this.props.blocks} position="above-atc-smart-3" _openFitGuide={this.props._openFitGuide} _optionChanged={this._optionChanged} /> : null}
        </div>
        {option.name === 'Size' ? <ProductPromos product={this.props.product} blocks={this.props.blocks} position="above-atc-smart" _openSizeGuide={this.props._openSizeGuide} _optionChanged={this._optionChanged} /> : null}
        <div className="option-values">
          {option.values.map((optionValue, j) => {
            return <div className="option-value" key={j}>
              <input type="radio" name={option.name} value={optionValue} checked={this.props[keyName] === optionValue} className="option-value-input" id={`${this.props.product.handle}-${option.name}-${optionValue}`} onChange={(e) => { this._optionChanged(keyName, optionValue) }} />
              <label htmlFor={`${this.props.product.handle}-${option.name}-${optionValue}`} className="option-value-name">
                <span className="option-value-inner">{optionValue}</span>
              </label>
            </div>
          })}
        </div>
      </div>
    })
  }

  formButton() {
    if (this.state.cartButton === 'loading') {
      return <button className="product-submit action-button submit button-loading" data-product-submit disabled type="submit">
        <div className="button-label-spinner">
          <SVG icon="spinner" />
        </div>
      </button>
    } else if (this.state.cartButton === 'success') {
      return <button className="product-submit action-button submit button-loading" data-product-submit disabled type="submit">
        {this.context.i18n.addedToCart}
      </button>
    } else if (this.state.cartButton === 'error') {
      return <button className="product-submit action-button submit button-loading" data-product-submit disabled type="submit">
        {this.context.i18n.addToCartError}
      </button>
    }

    const pov = this.props.currentVariant || this.props.product;

    if (pov.available) {
      return <button className="product-submit action-button submit button-active" data-product-submit type="submit">{this.context.i18n.addToCart}</button>
    } else if (this.props.product.tags.includes('BIS')) {
      return null;
    } else {
      return <button className="product-submit action-button submit addtocart-button-disabled" data-product-submit disabled type="submit">{this.context.i18n.soldOut}</button>
    }
  }

  waitlist() {
    const pov = this.props.currentVariant || this.props.product;

    if (!pov.available && this.props.product.tags.includes('BIS')) {
      return <Waitlist {...this.props} key={pov.id} _invalidVariant={this._invalidVariant} />
    }

    return null;
  }

  formSubmit(e) {
    e.preventDefault();
    if (this.props.currentVariant) {
      this.setState({ cartButton: 'loading' });
      const properties = {};
      if (e.detail && e.detail.fitFinder) {
        properties["_From Fit Finder"] = true;
      }
      if (this.props.metafields.variants[this.props.currentVariant.id].messaging.ship_note) {
        properties["_Ships"] = this.props.metafields.variants[this.props.currentVariant.id].messaging.ship_note
      }
      Axios.post('/cart/add.js', {
        'id': this.props.currentVariant.id,
        'quantity': 1,
        properties: properties
      }).then(() => {
        this.cartMini.refresh().then(() => {
          this.setState({cartButton: 'success' });
          this.cartMini.open(false);
        });

        window.dataLayer.push({ 'event': 'productAddToCart' });

        window._learnq = window._learnq || [];
        if (window.item && window.item.ProductID === this.props.product.id) {
          window._learnq.push(['track', 'Added to Cart', window.item]);
        } else {
          const klaviyoItem =  {
            "Name": this.props.product.title,
            "Brand": this.props.product.vendor,
            "Price": Shopify.formatMoney(this.props.currentVariant.price, Theme.moneyFormat),
            "CompareAtPrice": Shopify.formatMoney(this.props.currentVariant.compare_at_price, Theme.moneyFormat),
            "ProductID": this.props.product.id,
            "ImageURL": `https:${this.props.product.featured_image}`,
            "URL": `${window.location.origin}/products/${this.props.product.handle}`
          }
          window._learnq.push(['track', 'Added to Cart', klaviyoItem]);
        }
  
        window.dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'add': {
              'products': [{
                'name': this.props.product.title,
                'id': this.props.currentVariant.sku,
                'price': this.props.currentVariant.price / 100,
                'brand': this.props.product.vendor,
                'category': this.props.product.type,
                'variant': this.props.currentVariant.title,
                'quantity': 1
              }]
            }
          }
        });

        let location = 'Main Button';
        if (e.detail && e.detail.fitFinder) {
          location = 'Sizing Quiz';
        }

        window.heap && window.heap.track('ProductATC', { title: this.props.product.title, vendor: this.props.product.vendor, price: this.props.currentVariant.price, handle: this.props.product.handle, sku: this.props.currentVariant.sku, location: location });
      }, (fail) => {
        this.setState({cartButton: 'error'});
        console.error(fail);
      })
    } else {
      this._invalidVariant();
    }
  }

  shipNote() {
    if (this.props.currentVariant && this.props.currentVariant.available && this.props.metafields.variants[this.props.currentVariant.id].messaging.ship_note) {
      let shipModalContent = this.props.settings.shipModalContent.replace('XXX__XXX', this.props.metafields.variants[this.props.currentVariant.id].messaging.ship_note.toLowerCase())

      return <div className="inventory-message-wrapper">
        <p className="inventory-message">
          {this.props.metafields.variants[this.props.currentVariant.id].messaging.ship_note}
          <a href="#" aria-label="Info" onClick={this._openShipModal}>
            <SVG icon="info" />
          </a>
        </p>
        <Drawer open={this.state.shipModalOpen} heading={this.props.settings.shipModalHeading} content={shipModalContent} contentClass='ship-drawer' _close={this._closeShipModal} mountOnEnter={false} unmountOnExit={true} />
      </div>
    }
    return (null)
  }

  inventoryAlert() {
    if (this.props.currentVariant && this.props.currentVariant.available && this.props.currentVariant.inventory_management === 'shopify' && this.props.currentVariant.inventory_policy === 'deny' && this.props.currentVariant.inventory_quantity <= 5) {
      return <div className="inventory-alert">
        <div className="inventory-alert-text">
          Only {this.props.currentVariant.inventory_quantity} left!
        </div>
      </div>
    }
    return (null);
  }

  componentDidMount() {
    window.addEventListener('fitFinder:add', this.formSubmit)
  }

  componentDidUpdate() {
    if (this.state.cartButton === 'error' || this.state.cartButton === 'success') {
      this.timeout = setTimeout(() => {this.setState({cartButton: ''})}, 1000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('fitFinder:add', this.formSubmit)
    clearTimeout(this.timeout);
  }

  render() {
    return <div className="options" ref={this.ref}>
      <form method="POST" action="/cart/add" className="product-form" encType="multipart/form-data" onSubmit={this.formSubmit}>
        <ProductSwitcher {...this.props} />
        <ProductColors {...this.props} />
        <this.formData />
        <ProductPromos product={this.props.product} metafields={this.props.metafields} blocks={this.props.blocks} position="above-atc" _openSizeGuide={this.props._openSizeGuide} _openFitGuide={this.props._openFitGuide} _optionChanged={this.props.onOptionChange} />
        <this.inventoryAlert />
        <this.shipNote />
        <this.formButton />
      </form>
      <this.waitlist />
      <ProductPromos product={this.props.product} metafields={this.props.metafields} blocks={this.props.blocks} position="below-atc" _openSizeGuide={this.props._openSizeGuide} _openFitGuide={this.props._openFitGuide} _optionChanged={this.props.onOptionChange} />
    </div>
  }
}

ProductForm.contextType = ProductContext;